import { render, staticRenderFns } from "./TeamBonusHistoryModal.vue?vue&type=template&id=2c1ce0f1&"
import script from "./TeamBonusHistoryModal.vue?vue&type=script&lang=js&"
export * from "./TeamBonusHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports